import {err, success} from '@/commons/toast';
import app from '@/store/modules/app';

export default function handleMessage(type: string, text: string) {
    switch (type) {
        case 'error':
            if (app.isApp) {
                const messageData = {
                    type: 'error',
                    text,
                };
                app.displayMessage(messageData);
            } else {
                err(text);
            }
            break;
        case 'success':
            if (app.isApp) {
                const messageData = {
                    type: 'success',
                    text,
                };
                app.displayMessage(messageData);
            } else {
                success(text);
            }
            break;

        default:
            break;
    }
}
